<button class="export-button">
  <img
    class="export-icon"
    src="/assets/images/purpl/export.PNG"
    alt="export"
    (click)="exportEvent($event)"
    [title]="'Click to generate report'"
  />
</button>
